import React from "react";
import Typography from "@material-ui/core/Typography";
const AboutThisGuide = ({}) => {
  return (
    <React.Fragment>
      <Typography paragraph variant="h4">
        About This Guide
      </Typography>
      <Typography paragraph variant="h5">
        Introduction.
      </Typography>
      <Typography paragraph variant="body1">
        <strong>Invifo</strong> stands for{" "}
        <strong>Integrated Valuable Information</strong>. The company names
        itself is referring to the idea of providing ERP software with complete,
        seamless, and efficient integration between each business process but
        designed as simple as possible. The Invifo platform was initially
        designed for small-medium enterprises which doesn't have a proper system
        to automate and streamline their business process due to the high price
        of the majority ERP system license and the complicated process flow on
        most ERP system.
      </Typography>
      <Typography paragraph variant="body1">
        Founded in 2020 by Artha Pradyta & Aditya Prawira, Invifo is a
        multinational enterprise headquartered in Jakarta, Indonesia. The
        company founder's vision is to give anything that customer needs in a
        single platform and give them the best experiences and advantages by
        combining awesome technology like Artificial Intelligence, Machine
        Learning, Big Data, Robotic Process Automation, and the Internet of
        Things that help the customer easily and accurately take a decision for
        their business. The platform solution always follows 5 important
        principles:
      </Typography>
      <Typography paragraph variant="body1">
        <strong>Affordable</strong> : Offer the best pricing for small-medium
        enterprises.
      </Typography>
      <Typography paragraph variant="body1">
        <strong>Simple</strong> : Focus on what’s important process business.
      </Typography>
      <Typography paragraph variant="body1">
        <strong>Easy</strong> : Give intuitive UI experience for user ease.
      </Typography>
      <Typography paragraph variant="body1">
        <strong>Complete</strong> : Provide end-to-end features for general
        small-medium enterprises.
      </Typography>
      <Typography paragraph variant="body1">
        <strong>Responsive</strong> : Support how and user works at any time.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        Audience and Objective.
      </Typography>
      <Typography paragraph variant="body1">
        This manual is intended to be an introduction to the Invifo Enterprise
        platform and designed to be accessible to anyone using the platform. The
        Invifo platform is a collection of enterprise solutions in every key
        area like Finance, Sales, Procurement, Inventory, CRM, etc. This manual
        is structured to target those who intend to create, update, delete, or
        view transactions & configurations, generate reports, and understand the
        dashboard information.
      </Typography>
    </React.Fragment>
  );
};

export default AboutThisGuide;
